import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState } from 'react';
import ScrollToTop from './components/Layout/ScrollToTop';

// Context Providers
import { StoreProvider } from './context/StoreContext';
import { CartProvider } from './context/CartContext';
import { UpsellProvider } from './context/UpsellContext';
import { ToastProvider } from './context/ToastContext';

// Layout Components
import { Header } from './components/Layout/Header';
import { Footer } from './components/Footer/Footer';
import { SommelierAssistant } from './components/Product/SommelierAssistant';
import { UpsellModal } from './components/Cart/UpsellModal';

// Mobile Scanner Components - Temporarily disabled
// import { MobileScanner, MobileScannerButton } from './components/MobileScanner';

// Page Components
import { Home } from './components/Pages/Home';
import { SearchPage } from './components/Pages/SearchPage';
import { CategoryPage } from './components/Pages/CategoryPage';
import { CategoriesPage } from './components/Pages/CategoriesPage';
import { ProductDetailPage } from './components/Pages/ProductDetailPage';
import { CartPage } from './components/Pages/CartPage';
import { CheckoutPage } from './components/Pages/CheckoutPage';
import { ThankYouPage } from './components/Pages/ThankYouPage';
import { GrapeVarietyInfoPage } from './components/Pages/GrapeVarietyInfoPage';
import { RegionInfoPage } from './components/Pages/RegionInfoPage';
import { SubregionInfoPage } from './components/Pages/SubregionInfoPage';
import { SubregionsListPage } from './components/Pages/SubregionsListPage';
import { CountryInfoPage } from './components/Pages/CountryInfoPage';
import { GrapeVarietiesPage } from './components/Pages/GrapeVarietiesPage';
import InfoOverviewPage from './components/Pages/InfoOverviewPage';
import CountriesListPage from './components/Pages/CountriesListPage';
import RegionsListPage from './components/Pages/RegionsListPage';
import WineStylesPage from './components/Pages/WineStylesPage';
import RegionsOverviewPage from './components/Pages/RegionsOverviewPage';
import GrapeVarietiesOverviewPage from './components/Pages/GrapeVarietiesOverviewPage';
import { NotFoundPage } from './components/Pages/NotFoundPage';

// Main App Component
function App() {
  // const [isScannerOpen, setIsScannerOpen] = useState(false);

  // const openScanner = () => {
  //   setIsScannerOpen(true);
  // };

  // const closeScanner = () => {
  //   setIsScannerOpen(false);
  // };

  return (
    <StoreProvider>
      <CartProvider>
        <ToastProvider>
          <UpsellProvider>
          <Router>
            <ScrollToTop />
            <div className="app">
              <Header />
              <Routes>
                <Route path="/" element={<Navigate to="/search" replace />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/home" element={<Home />} />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/categories/:category" element={<CategoryPage />} />
                <Route path="/categories/:type/:subcategory" element={<CategoryPage />} />
                <Route path="/produit/:productId" element={<ProductDetailPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/thank-you" element={<ThankYouPage />} />
                
                {/* Info Pages - New Structure */}
                <Route path="/info" element={<InfoOverviewPage />} />
                <Route path="/info/styles" element={<WineStylesPage />} />
                <Route path="/info/regions" element={<RegionsOverviewPage />} />
                <Route path="/info/cepages" element={<GrapeVarietiesOverviewPage />} />
                <Route path="/info/countries" element={<CountriesListPage />} />
                <Route path="/info/countries/:country" element={<CountryInfoPage />} />
                <Route path="/info/countries/:country/regions" element={<RegionsListPage />} />
                <Route path="/info/countries/:country/regions/:region" element={<RegionInfoPage />} />
                <Route path="/info/countries/:country/regions/:region/subregions" element={<SubregionsListPage />} />
                <Route path="/info/countries/:country/regions/:region/cepages" element={<GrapeVarietiesPage />} />
                <Route path="/info/countries/:country/regions/:region/cepages/:grapeVariety" element={<GrapeVarietyInfoPage />} />
                <Route path="/info/countries/:country/regions/:region/:subregion" element={<SubregionInfoPage />} />
                <Route path="/info/countries/:country/regions/:region/:subregion/cepages" element={<GrapeVarietiesPage />} />
                <Route path="/info/countries/:country/regions/:region/:subregion/cepages/:grapeVariety" element={<GrapeVarietyInfoPage />} />
                <Route path="/info/countries/:country/cepages/:grapeVariety" element={<GrapeVarietyInfoPage />} />
                
                {/* Legacy routes for backward compatibility */}
                <Route path="/info/:country/regions/:region" element={<RegionInfoPage />} />
                <Route path="/info/:country/regions/:region/subregions" element={<SubregionsListPage />} />
                <Route path="/info/:country/regions/:region/cepages" element={<GrapeVarietiesPage />} />
                <Route path="/info/:country/regions/:region/cepages/:grapeVariety" element={<GrapeVarietyInfoPage />} />
                <Route path="/info/:country/regions/:region/:subregion" element={<SubregionInfoPage />} />
                <Route path="/info/:country/regions/:region/:subregion/cepages" element={<GrapeVarietiesPage />} />
                <Route path="/info/:country/regions/:region/:subregion/cepages/:grapeVariety" element={<GrapeVarietyInfoPage />} />
                <Route path="/info/:country/cepages/:grapeVariety" element={<GrapeVarietyInfoPage />} />
                <Route path="/info/:country" element={<CountryInfoPage />} />
                
                {/* 404 Route */}
                <Route path="/404" element={<NotFoundPage />} />
                
                {/* 404 Catch-all route */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              <Footer />
              
              {/* Sommelier Assistant - Floating Chat Button */}
              <SommelierAssistant />
              <UpsellModal />

              {/* Mobile Scanner Button - Temporarily disabled */}
              {/* <MobileScannerButton onClick={openScanner} /> */}
              
              {/* Mobile Scanner Modal - Temporarily disabled */}
              {/* <MobileScanner 
                isOpen={isScannerOpen} 
                onClose={closeScanner} 
              /> */}
            </div>
          </Router>
          </UpsellProvider>
        </ToastProvider>
      </CartProvider>
    </StoreProvider>
  );
}

export default App; 